module.exports = __webpack_public_path__ + "img/menu-token-icon.734691c7.svg";